import { mapActions, mapGetters, mapMutations } from 'vuex';
import CustomiseRoomModal from '@/components/modals/nav/CustomiseRoomModal.vue';
import InviteExternalGuestsModal from '@/components/modals/admin/InviteExternalGuestsModal.vue';
import AddPasswordModal from '@/components/modals/admin/AddPasswordModal.vue';

export default {
  computed: {
    adminMenuItems() {
      return [
        {
          icon: 'edit',
          text: 'Customise',
          show:
            (this.roomLifetime === 'fixed' && this.userLevel > 0) ||
            (this.roomLifetime === 'temporary' && (this.isUserCreator || this.userLevel > 0)),
          click: this.customiseRoom
        },
        {
          icon: 'lock',
          text: 'Room Password',
          show: this.isAllowed('room.lobby.configure') && !this.isHub && this.isPremiumEnabled && (this.isUserCreator || this.userLevel > 0),
          style: { background: '#454545' },
          toggle: { offText: 'OFF', onText: 'ON', value: Boolean(this.getSpacePasswordEnabled), disabled: Boolean(!this.getSpaceLobbyEnabled) },
          click: this.toggleRoomPassword,
          disabled: !this.getSpaceLobbyEnabled,
          disabledText: 'Turn Guest Lobby on to enable password'
        },
        {
          icon: 'clock',
          text: 'Guest Lobby',
          // hidden for now
          show: this.isAllowed('room.lobby.configure') && !this.isHub && this.isPremiumEnabled && (this.isUserCreator || this.userLevel > 0),
          toggle: { offText: 'OFF', onText: 'ON', value: Boolean(this.getSpaceLobbyEnabled) },
          click: this.toggleRoomLobby
        },
        {
          icon: 'user',
          text: 'Invite Guest',
          show: this.isAllowed('room.inviteGuests') && !this.isHub && this.isPremiumEnabled && (this.isUserCreator || this.userLevel > 0),
          style: { background: '#454545' },
          click: this.inviteExternalGuests
        }
      ];
    },
    ...mapGetters({
      userLevel: 'current_user/currentAreaPermissionNo',
      user: 'current_user/data',
      isGuest: 'current_user/isGuest',
      isPremiumEnabled: 'getCurrentAreaPremiumFeaturesEnabled',
      data: 'getCurrentSpacePageData',
      isAllowed: 'permissions/isAllowed',
      getSpaceLobbyEnabled: 'getSpaceLobbyEnabled',
      getSpacePasswordEnabled: 'getSpacePasswordEnabled'
    }),
    roomLifetime: vm => vm.data.location.locationLifestyle,
    isUserCreator: (vm) => vm.user.email === vm.data.hostEmail,
    isHubOrLounge: (vm) => vm.isHub || vm.data.location.spaceType === 'lounge',
    isHub: (vm) => vm.data.location.spaceType === 'hub'
  },
  methods: {
    ...mapActions(['modal/open', 'routing/goToCustomise', 'handleToggleRoomLobby', 'handleRemoveRoomPassword', 'popups/guest/confirmTurnOffGuestLobby']),
    ...mapMutations(['PASSWORD_ENABLED', 'LOBBY_ENABLED']),
    customiseRoom() {
      if (!this.isHubOrLounge) {
        this['modal/open']([CustomiseRoomModal]);
      } else {
        // Hub or loungue can only be customized from SpaceSettings
        this['routing/goToCustomise']();
      }
    },
    async toggleRoomPassword() {
      this.setPasswordEnabled(!this.getSpacePasswordEnabled)
    },
    async toggleRoomLobby() {
      let confirmCallback = () => this.setRoomLobby(!this.getSpaceLobbyEnabled)
      let cancelCallback = () => this.getSpaceLobbyEnabled = !this.getSpaceLobbyEnabled //put value back if turn off is cancelled
      if(this.getSpaceLobbyEnabled) { //if turning guest off
        this['popups/guest/confirmTurnOffGuestLobby']([cancelCallback,confirmCallback])
        return
      }
      confirmCallback()
    },
    async setPasswordEnabled(enabled) {
      this['PASSWORD_ENABLED'](enabled)

      if (enabled) {
        return new Promise((resolve) => {
          this['modal/open']([
            AddPasswordModal,
            {
              onCancel: () => {
                this['PASSWORD_ENABLED'](false)
                resolve();
              },
              onSave: (res) => {
                if (!res?.success) {
                  this['PASSWORD_ENABLED'](false)
                }

                resolve(res);
              }
            }
          ]);
        });
      } else {
        let res = await this['handleRemoveRoomPassword'](this.data.id);
        if (!res?.success) this['PASSWORD_ENABLED'](true) //reset value if it didn't work

        return res;
      }
    },
    async setRoomLobby(enabled, showSuccessPopup = true) {
      this['LOBBY_ENABLED'](enabled)

      let res;

      if (!enabled && this.getSpacePasswordEnabled) { //turn off room password when turning off lobby
        // disable password first
        res = await this.setPasswordEnabled(false);

        if (!res?.success) { // failed to disable password
          this['LOBBY_ENABLED'](false)
          return
        }
      }

      let res2 = await this['handleToggleRoomLobby']([this.data.id, enabled, showSuccessPopup]);
      if (!res2?.success) this['LOBBY_ENABLED'](!enabled); //reset if fails
    },
    inviteExternalGuests() {
      this['modal/open']([InviteExternalGuestsModal]);
    }
  }
};
